import { Box, Typography } from "@mui/material"
import StatusBadge from "../../../v2/MUI_custom_component/Badge/StatusBadge"

const BenefitCard = ({benefit, sx}) => {
    return (
        <Box 
            sx={{ p: 1,
            borderRadius: 2,
            border: '1px solid #D9D9D9',
            minHeight: { xs: 110, md: 130},
            background: '#FFFFFF',
            ...sx
        }}>
            <Box sx={{ display: 'flex', justifyContent: 'end', marginTop: -1, marginRight: -1}}>
            <StatusBadge
                label={benefit?.status?.label}
                status={benefit?.status?.label}
                variant="text"
                size="medium"
            />
            </Box>
            <Box sx={{ display: "flex", gap: 0.5 }}>
                <Box
                    component="img"
                    src={benefit?.logo_url}
                    alt="logo"
                    sx={{
                        maxHeight: { xs: 32, md: 32 },
                        maxWidth: { xs: 32, md: 32 },
                        p:'2px'
                    }}
                />
                <Box sx={{ display: "flex", flexDirection: "column", mt: -0.5}}>
                    <Typography variant="labelD">{benefit?.benefit_name}</Typography>
                    <Typography variant="p3" sx={{ color: '#666'}}>{benefit?.amount}</Typography>
                </Box>
            </Box>
        </Box>
    )
}

export default BenefitCard